import { render, staticRenderFns } from "./MendiStatistics.vue?vue&type=template&id=6c8eceb8&lang=pug&"
import script from "./MendiStatistics.vue?vue&type=script&lang=js&"
export * from "./MendiStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MendiStatistics.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports